<nav
  class="header navbar navbar-expand-lg navbar-dark"
  aria-label="Header and account navigation"
>
  <div class="container-fluid">
    <h1 class="navbar-brand-heading">
      <a
        [attr.aria-label]="'Indiana Secretary of State Diego Morales'"
        class="navbar-brand"
        href="#"
      >
        <img
          [addAaTags]="'Indiana Logo'"
          src="/img/logo.png"
          width="30"
          height="30"
          class="d-inline-block align-top me-2"
        />
        Indiana Secretary of State Diego Morales
        <div class="ml-5">Admin Panel</div>
      </a>
    </h1>
    <button
      addAaTags="Toggle navigation"
      (click)="isNavbarCollapsed = !isNavbarCollapsed"
      (keydown.enter)="isNavbarCollapsed = !isNavbarCollapsed"
      (keydown.space)="isNavbarCollapsed = !isNavbarCollapsed"
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      [attr.aria-expanded]="isNavbarCollapsed ? 'false' : 'true'"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div
      class="collapse navbar-collapse justify-content-end"
      [ngbCollapse]="isNavbarCollapsed"
      id="navbarSupportedContent"
    >
      <ul class="navbar-nav mb-2 mb-lg-0">
        @if(isLoggedIn) {
        <li class="nav-item dropdown avatar-dropdown" ngbDropdown display="dynamic">
          <button
            type="button"
            class="nav-link dropdown-toggle avatar-dropdown btn btn-link p-0"
            ngbDropdownToggle
            id="navbarDropdown"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            aria-label="User menu"
            title="User menu"
          >
            <div class="ind-avatar" aria-hidden="true">{{ getInitials }}</div>
          </button>
          <div
            ngbDropdownMenu
            class="dropdown-menu"
            aria-labelledby="navbarDropdown"
          >
            <div class="dropdown-item-text">{{ getUserName }}</div>
            <div class="dropdown-divider"></div>
            <button
              type="button"
              aria-label="Log out from your account"
              [attr.aria-posinset]="1"
              [attr.aria-setsize]="1"
              ngbDropdownItem
              routerLinkActive="active"
              class="dropdown-item"
              (click)="logout()"
              (keydown.enter)="logout()"
              (keydown.space)="logout()"
            >
              Logout
            </button>
          </div>
        </li>
        }
      </ul>
    </div>
  </div>
</nav>
